import BlockAccordion from 'components/BlockAccordion';
import ComponentPlaceholder from 'components/ComponentPlaceholder';
import type { FaqArticle, Field, SitecoreBlockProps } from 'models/sitecore';
import { getEditorMargin } from 'utils/business-logic';
import { filterTruthy } from 'utils/collection';

interface Props extends SitecoreBlockProps {
	fields?: {
		articles?: FaqArticle[];
		heading?: Field<string>;
	};
}

export default function FAQs({ fields, params }: Props) {
	if (!fields) {
		return null;
	}

	const items = filterTruthy(
		fields.articles?.map((article) => ({
			content: article.fields.content.value,
			heading: article.fields.summary.value,
		})),
		'content',
		'heading',
	);

	if (items.length === 0) {
		return (
			<ComponentPlaceholder
				className={getEditorMargin(params)}
				componentName="FAQs"
				description="Requires at least one article that has a heading and content"
			/>
		);
	}

	return (
		<BlockAccordion
			className={getEditorMargin(params)}
			items={items}
			heading={fields.heading}
			headingLevel={params?.heading}
		/>
	);
}
FAQs.displayName = 'FAQs';
